import { render } from "./ContactsListPage.vue?vue&type=template&id=06ff0596&ts=true"
import script from "./ContactsListPage.vue?vue&type=script&lang=ts"
export * from "./ContactsListPage.vue?vue&type=script&lang=ts"

import "./ContactsListPage.vue?vue&type=style&index=0&id=06ff0596&lang=css"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/package/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__